<template>
  <span v-if="booking !== null">
    <div class="paymentWrapper">
      <div class="wrapperCheckout flex justify-around sm:flex-col">
        <BookingDetail
          :booking="booking"
          :showShare="false"
          :showOpenFacility="false"
          :showResourceName="true"
          class="paymentBoxLeft p-6 pt-8 md:mr-6"
        />
        <div class="paymentBoxRight md:p-6 sm:pt-4 md:mr-6 sm:mb-6 relative">
          <h2 class="sm:hidden">
            {{
              isMatch
                ? $t('checkout').toUpperCase()
                : booking?.hidePaymentMethods
                  ? $t('proceed_to_payment').toUpperCase()
                  : $t('pay_mode').toUpperCase()
            }}
          </h2>
          <div class="backgroundPayment md:mt-8 sm:pb-7">
            <div
              v-if="showShared"
              :class="{ customBorder: fullPayment === false }"
              class="paymentOption cursor-pointer flex items-center flex-row p-6 justify-between sm:flex-col sm:justify sm:relative"
              v-on:click="setFullPayment(false)"
            >
              <div class="flex items-center">
                <div
                  v-if="!isMatch"
                  class="check paySelected mr-6 relative"
                ></div>
                <div class="flex flex-col">
                  <div v-if="!isMatch" class="w-full">
                    <h2 class="mb-2 text-xl sm:text-sm">
                      {{ $t("shared_payment") }}
                    </h2>
                    <p class="text-sm playerSubtitle pr-2 sm:text-xs sm:mb-2">
                      <span class="text-white">
                        {{ $t("you_assume_shared_payment") }}</span
                      >
                    </p>
                  </div>
                  <div v-else class="w-full">
                    <h2  class="mb-2 text-xl sm:text-sm">
                      {{ $t("payment") }}
                    </h2>
                  </div>
                  <div class="sm:flex mr-4">
                       <p class="text-lg sm:text-lg" v-html="sharedPaymentPriceStr"></p>
                  </div>
                </div>
              </div>
              <div
                class="customBorder addPlayers sm:p-1 p-3 flex justify-center sm:absolute overflow-hidden break-words items-center"
              >
                <div @click="goToAddPlayers()">
                  <div class="playerIcon pb-4 relative"></div>

                  <p
                    v-if="!playersMode && !isMatch"
                    class="text-sm text-center sm:text-xs"
                  >
                    {{ $t("add_players") }}
                  </p>
                  <p
                    v-if="!playersMode && isMatch"
                    class="text-sm text-center sm:text-xs"
                  >
                    {{ $t("edit_positions") }}
                  </p>
                  <p v-if="playersMode" class="text-sm text-center sm:text-xs">
                    {{ $t("edit_positions") }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="playersMode" class="containerPayPlayers">
              <div
                v-if="getOwner() !== undefined"
                class="checkoutPlayers w-full mt-4 p-2"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center">
                    <!-- <div class="firstCheck ml-4 md:ml-6 mr-6 relative"></div> -->
                    <div class="flex items-center sm:justify-center">
                      <img
                        class="sm:w-8 sm:h-8 mr-3 md:w-12"
                        src="../assets/images/genericPlayer.png"
                        alt=""
                      />
                      <div class="mr-2">
                        <p class="playerSubtitle sm:text-xs">
                          {{ getOwner().name }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <span v-html="getPrice(getOwner().customerId)"></span>
                </div>
              </div>
              <div
                v-for="(player, index) in booking.players.filter(
                  (y) =>
                    y.owner === false &&
                    (!y.hasOwnProperty('paid') || y.paid === false)
                )"
                :key="index"
                class="checkoutPlayers w-full mt-4 p-2"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center">
                    <img
                      class="sm:w-8 sm:h-8 mr-3 md:w-12"
                      src="../assets/images/genericPlayer.png"
                      alt=""
                    />
                    <p class="playerSubtitle sm:text-xs">
                      {{ player.name ? player.name : "Guest Player" }}
                    </p>
                  </div>
                  <div v-if="player.amount && isBooked" class="playerSubtitle sm:text-xs">
                    {{ player.amount.amountStr }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="showFull"
              :class="{ customBorder: fullPayment === true }"
              v-on:click="setFullPayment(true)"
              class="paymentOption cursor-pointer flex md:items-center md:flex-row p-6 justify-between md:mt-8 sm:mt-4 sm:flex-col"
            >
              <div class="flex items-center">
                <div class="check paySelected mr-6 relative"></div>
                <div class="flex flex-col">
                  <div class="flex-col w-full">
                    <h2 class="mb-2 text-xl sm:text-sm">
                      {{ $t("full_payment") }}
                    </h2>
                    <p class="text-sm playerSubtitle pr-2 sm:text-xs sm:mb-2">
                      <span class="text-white">
                        {{ $t("you_assume_full_payment") }}</span
                      >
                    </p>
                  </div>
                  <div class="flex">
                     <div>
                <div v-if="fullPaymentPriceWithoutTaxes">
                      <p v-html="Format.addTaxString(fullPaymentPriceStr)"></p>
                    </div>
                    <div v-else>
                      <p class="text-lg sm:text-lg">{{ fullPaymentPriceStr }}</p>
                    </div>
              </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="showInHOuse"
              v-on:click="setFullPayment(true)"
              class="customBorder paymentOption cursor-pointer flex md:items-center md:flex-row p-6 justify-between md:mt-8 sm:mt-4 sm:flex-col"
            >
              <div class="flex items-center">
                <div class="check paySelected mr-6 relative sm:mt-6"></div>
                <div>
                  <h2 class="mb-2 text-xl sm:text-sm">
                    {{ $t("pay_in") }}
                    {{ capitalizeFirstLetter(booking.tenant) }}
                  </h2>
                </div>
              </div>
            </div>
            <div
                v-if="!payInHouse"
                class="bottomTotal flex flex-col pb-4 p-4"
            >
                  <div
                  v-if="payWarningMsg != '' && payShared"
                  class="flex items-center bg-blue-500 text-white text-xs px-4 py-3 mt-2"
                  role="alert"
                  style="border-radius: 28px"
                >
                  <svg
                    class="fill-current w-6 h-6 mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"
                    ></path>
                  </svg>
                  <p style="white-space: pre-line">
                    {{ payWarningMsg }}
                  </p>
                </div>
                
                <div class="flex flex-row items-center justify-between w-full mt-6">
                  <h2 class="text-xl sm:text-sm flex-shrink-0">{{ $t("total") }}</h2>
                  
                  <div class="flex-1 text-right mx-4">
                      <p class="text-2xl sm:text-lg" v-html="displayedPrice"></p>
                  </div>

                  <div 
                    v-if="isMatch && !fromJoin"
                    class="customBorder addPlayers p-3 flex justify-center overflow-hidden break-words items-center flex-shrink-0"
                  >
                    <div @click="goToAddPlayers()">
                      <div class="playerIcon pb-4 relative"></div>
                      <p class="text-sm text-center sm:text-xs">
                        {{ $t("edit_positions") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            <button 
              v-disable-on-click:proced-to-pay
              class="flex justify-center buttomPayMode md:mt-8 sm:mt-4 mb-8 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              @click="procedToPay()"
            >
              {{ $t("text_continue") }}
          </button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import BookingDetail from "../components/booking/bookingDetail.vue";
import { Format } from "@/helpers/formatHelper";
import { BookingStatus, BookingType, PaymentType, RetentionType } from "@/enum/constants";
import store from "../store";
import { BookingApi } from "@/service/BookingApi";
import { Player } from "@/custom-models/player";
import { customGlobalError } from "@/helpers/errorHelper";
import { Booking } from "@/custom-models/booking";
import { Price } from "@/custom-models/price";
import LocalStorage from "@/helpers/localStorage";
import { BookingHelper, returnSportPlayers } from "@/helpers/bookingHelper";
import { AppsHelper } from "@/helpers/appsHelper";
import MatchHelper from "@/helpers/matchtHelper";
import { capitalizeFirstLetter, formatDate } from "@/helpers/dateHelper";
import { encodeString, decodeString, useRefreshWatcher, decodeBase64 } from "@/helpers/dataHelper";
import { CheckoutPayment } from "@/custom-models/checkoutPayment";
import CustomerHelper from "@/helpers/customerHelper";
import { MatchFilter } from "@/custom-models/matchFilter";

export default defineComponent({
  name: "checkoutView",
  components: {
    BookingDetail,
  },
  data() {
    return {
      booking: {} as Booking,
      fullPayment: true,
      playersMode: false,
      prices: [] as Price[],
      urlRedirect: null,
      fromJoin: false,
      cancellationLimitDate: "",
      isMatch: false,
      payInHouse: false as boolean,
      payShared: false as boolean,
      payFull: false as boolean,
      showShared: false as boolean,
      showFull: false as boolean,
      showInHOuse: false as boolean,
      fullPaymentPrice: null as number | null,
      sharedPaymentPriceStr: "",
      fullPaymentPriceStr: "",
      sharedPaymentTotalStr: "",
      size: null as any | null,
      fullPaymentPriceWithoutTaxes: false as boolean,
      sharedPaymentPriceWithoutTaxes: false as boolean,
      totalPriceWithoutTaxes:false as boolean,
      Format: Format,
      isBooked: false,
      retentionType: RetentionType.NORMAL,
      payWarningMsg:""
    };
  },
  computed: {
    displayedPrice(): string {
      const priceStr = this.fullPayment || this.isMatch
        ? this.fullPaymentPriceStr
        : this.sharedPaymentTotalStr

      return this.totalPriceWithoutTaxes
        ? this.Format.addTaxString(priceStr)
        : priceStr
    }
  },
  async created() {
    const query = this.$route.query.pl;
    if (query === undefined || query === null || query === "") {
      customGlobalError(this.$t("wrong_url"), "/");
      return;
    }

    let utf8Query = null;
    try {
      utf8Query = decodeString(query.toString());
    } catch (error) {
      customGlobalError(this.$t("wrong_url"), "/");
      return;
    }
    try {
      this.booking = JSON.parse(utf8Query);
    } catch (error) {
      customGlobalError(this.$t("wrong_url"), "/");
      return;
    }
    if (this.booking === null) {
      return;
    }
    if(this.booking?.status?.code == BookingStatus.BOOKED){
      this.isBooked = true //sabemos que estamos en checkout, en reserva ya creada
    }
    if(this.booking.price.amountStr){
      this.booking.price.amountStr = decodeBase64(this.booking.price.amountStr);
    }
    this.size = this.booking.size;
    if (this.size !== undefined && this.size.code !== undefined) {
      this.size = this.size.code;
    }
    if(!this.size ){
      if(this.booking.attributes){
        this.size = this.booking.attributes.size
      }
    }

    if (
      (this.booking.type !== undefined &&
        this.booking.type.code === BookingType.MATCH) ||
      this.booking.matchRequest
    ) {
      this.isMatch = true;
      this.fullPayment = false;
      // Add customer as first player to get personalized price
      const user = localStorage.getItem("user");
      if (user === null || user === "") {
        store.commit("openLogin");
        return;
      }

      if (this.booking.players === undefined) {
        this.booking.players = [];
        this.booking.players.push({
          customerId: JSON.parse(user).id,
          owner: true,
          paid: false,
        });
      }
    }

    if (this.booking.id !== undefined && this.booking.id !== null) {
      this.fromJoin = true;
    }
    if (this.booking && this.booking.players && this.booking.players.length > 0) {
      if (!this.isMatch) {
        this.playersMode = true;
        this.fullPayment = false;
        const owner = this.getOwner();
        if (owner !== undefined) {
          owner.selected = true;
        }
      }
      await this.loadPrices();
      
      return;
    }
    this.booking.players = [];
    this.refreshPrices();
  },
  mounted() {
    useRefreshWatcher(() => { this.loginRefresh(); });
    const user = localStorage.getItem("user");
      if (user === null || user === "") {
        store.commit("openLogin");
        return;
    }
    document.body.style.background = "none"; // todo hacerlo bien con layouts
    this.fixIphoneHeight();
      if (this.booking.allowedPaymentMethods) {
      this.payInHouse = this.booking.allowedPaymentMethods.some((allowedPaymentMethod) => allowedPaymentMethod.code === PaymentType.IN_HOUSE);
      this.showInHOuse = this.payInHouse && !this.playersMode;
      if (this.showInHOuse) {
        return;
      }

      this.payShared = this.booking.allowedPaymentMethods.some((allowedPaymentMethod) => allowedPaymentMethod.code === PaymentType.SHARED);
      this.showShared = !this.payInHouse && this.payShared && !this.isMatch;
      this.payFull = this.booking.allowedPaymentMethods.some((allowedPaymentMethod) => allowedPaymentMethod.code === PaymentType.FULL);
      this.showFull = !this.payInHouse && this.payFull && !this.playersMode && !this.isMatch;
      if(!this.showFull){
        this.setFullPayment(false);
      }
      if (this.booking?.hidePaymentMethods) {
        this.showInHOuse = false;
        this.showShared  = false;
        this.showFull = false;
      }
    }
  },
  methods: {
    getRetentionMsg(){
      if ( this.retentionType === RetentionType.NORMAL && !this.isMatch) {
          return this.payWarningMsg = this.$t("checkout_retention_msg")
      }
      this.payWarningMsg = ""
    },
    capitalizeFirstLetter,
    async loginRefresh(){
      window.location.reload();
    },
    async refreshPrices() {
      const user = CustomerHelper.getUser();
      if (user) {
        const userPrice = {
          customerId: user.id,
          name: user.fullName,
          position: 0,
          owner: true,
          paid: false,
          image: user.image,
          selected: true,
        };
        this.booking.players!.push(userPrice);
        await this.getPrices();
      }
    },
    getPriceRequest() {
      const priceType = this.isMatch ? BookingType.MATCH : BookingType.BOOKING;
      const numPlayers = returnSportPlayers(Number(this.size));
      let idArray = this.booking.players !== undefined
            ? this.booking.players
                .filter((y) => y.paid === false)
                .map((y: any) => y.customerId)
            : []; // Array inicial con IDs
      const remainingPlayers = numPlayers - idArray.length;

      if (remainingPlayers > 0) {
        for (let i = 0; i < remainingPlayers; i++) {
          idArray.push("");
        }
      }
      return {
        resourceId: this.booking.resourceId as number,
        start: formatDate(new Date(this.booking.date)),
        duration: this.booking.duration,
        sport: this.booking.sport,
        customerIds:idArray,
        tenantId: this.booking.tenantId,
        type: priceType,
      };
    },
    async getPrices() {
      if (this.booking === null) {
        return;
      }
      const pricesRequest = this.getPriceRequest();
      const response = await BookingHelper.getPrices(pricesRequest);
      if (response) {
        this.prices = response.players;
        this.mapPrices(response);
        
        return;
      }
      customGlobalError(
        this.$t("oops_technical_problems_try_again_in_a_few_minutes")
      );
    },
    mapPlayersWithPrices(){
      this.booking.players = this.booking.players?.map(j => {
        const match = this.prices.find(p => p.playerId === j.playerId);
        return {
          ...j,
          amount: match ? match.amount : null
        };
      });
    },
    async loadPrices() {
      if (this.booking === null) {
        return;
      }

      let response;
      if(this.isBooked){
        const playerIds: number[] = (this.booking.players ?? []).map((p: any) => p.playerId);
        response = await BookingHelper.getPlayersPrices(this.booking.id!, playerIds);
        this.prices = response.prices
      }else{
        const pricesRequest = this.getPriceRequest();
        response = await BookingHelper.getPrices(pricesRequest);
        this.prices = response.players;
      }
      if (response) {
        this.mapPrices(response);
        return;
      }
      customGlobalError(
        this.$t("oops_technical_problems_try_again_in_a_few_minutes")
      );
    },
    goToAddPlayers() {
      const user = localStorage.getItem("user");
      if (user === null || user === "") {
        store.commit("openLogin");
        return;
      }

      this.$router.push(this.getUrlPlayers());
    },
    getUrlPlayers() {
      if (this.fromJoin) {
        return `/booking-join/${this.booking.id}`;
      }
      return `/players?pl=${this.$route.query.pl}`;
    },
    getOwner() {
      const players: any = this.booking.players;
      return players.find((y: any) => y.owner);
    },
    getPrice(id: string | null) {
      if (this.prices.length === 0) {
        return;
      }
      if (id === "") {
        id = null; // this.prices not assigned customers comes with id null
      }
      const price: any = this.prices.find(
        (y: any) => y.customerId === id || y.customerId === null
      ); //add null because a player can't be in takus

      if (price === undefined || price === null) {
        customGlobalError(
          this.$t("oops_technical_problems_try_again_in_a_few_minutes")
        );
        return;
      }
      if(price.price.withoutTaxes){
        return Format.addTaxString(price.price.amountStr)
      }
      return price.price.amountStr;
    },
    mapPrices(response:any){
      if(this.isBooked){
        if(this.isMatch){
          this.fullPaymentPriceStr = response.totalAmount.amountStr
        }
        this.sharedPaymentTotalStr = response.totalAmount.amountStr
         return this.mapPlayersWithPrices();
      }
      this.fullPaymentPriceStr = response.totalAmount.amountStr
      this.fullPaymentPriceWithoutTaxes = response.totalAmount.withoutTaxes
      if(this.getOwner()){
        this.sharedPaymentPriceStr = this.getPrice(this.getOwner().customerId);
      }
      this.sharedPaymentPriceWithoutTaxes = response.totalAmount.withoutTaxes
      this.sharedPaymentTotalStr = response.totalAmountShared.amountStr
      this.totalPriceWithoutTaxes = response.totalAmount.withoutTaxes //fullpayment as default
      this.retentionType = response.retentionType.code;
      this.getRetentionMsg();
      this.checkShowTaxes();
    },
    selectPlayer(player: Player) {
      if (player.selected !== true) {
        player.selected = true;
        return;
      }

      player.selected = false;
    },
    async procedToPay() {
      const user = localStorage.getItem("user");
      let response = null;
      if (user === null || user === "") {
        store.commit("openLogin");
        return;
      }

      if (this.fromJoin) {
        let players: any = {};
        if (this.booking.players !== undefined) {
          players = this.booking.players
            .filter((y: any) => y.paid === false && y.playerId !== undefined)
            .map((y: any) => y.playerId);
        }
        const response = await BookingApi.createSale(
          this.booking.id as string,
          players
        );
        switch (response.status) {
          case 201:
            this.goToPay(
              response.data.saleId,
              response.data.bookingId,
              response.data.cancellationLimit
            );
            break;
          case 409:
            customGlobalError(this.$t("purchase_process_expired"));
            break;
        }
        return;
      }
      var request: any = {
        resourceId: this.booking.resourceId as number,
        start: this.booking.date,
        duration: this.booking.duration,
        sport: this.booking.sport,
        players: this.configurePlayers(),
        tenantId: this.booking.tenantId,
        origin: BookingHelper.getOrigin(),
        paymentType: this.fullPayment ? PaymentType.FULL : PaymentType.SHARED,
        type: this.booking.type,
      };
      if (this.payInHouse) {
        request.paymentType = PaymentType.IN_HOUSE;
      }
      store.commit("setLoading", true);
      if (this.isMatch) {
        let matchRequest = this.booking.matchRequest;
        matchRequest.attributes = this.booking.attributes as MatchFilter
        matchRequest.players = this.configurePlayers()
        matchRequest.minLevel = this.booking.minLevel
        matchRequest.maxLevel = this.booking.maxLevel
        response = await MatchHelper.createMatch(matchRequest);
      } else {
        response = await BookingApi.prebooking(request);
      }
      let id = response.data.bookingId;
      this.booking.name = response.data.booking.bookingBlocks[0].name;
      this.booking.players = response.data.booking.players;
      store.commit("setLoading", false);
      window.dispatchEvent(new Event('proced-to-pay'));
      if (response.data.free === true) {
        this.booking.id = id;
        LocalStorage.addWithTimout(id as string, this.booking);
        return this.$router.push("/checkout-ok/" + id);
      }

      switch (response.status) {
        case 201:
          this.goToPay(
            response.data.saleId,
            id,
            response.data.cancellationLimit
          );
          break;
        case 409:
          customGlobalError(this.$t("purchase_process_expired"));
          break;
      }
    },
    goToPay(saleId: string, bookingId: string, cancellationLimit: string) {
      this.booking.id = bookingId;
      LocalStorage.addWithTimout(saleId, this.booking);
      const paymentJson: CheckoutPayment = {
        saleId: saleId,
        saleType: this.isMatch ? BookingType.MATCH : BookingType.BOOKING,
      };
      if (cancellationLimit !== null) {
        paymentJson.cancellationDate = cancellationLimit;
      }
      return this.$router.push({
        name: "checkoutPaymentViewCoded",
        params: { data: encodeString(JSON.stringify(paymentJson)) },
      });
    },
    configurePlayers() {
      if (this.fullPayment) {
        this.booking.players = [];
        return this.booking.players;
      }
      // shared payments, not players assigned
      if (
        this.booking.players === undefined ||
        this.booking.players === null ||
        this.booking.players.length === 0
      ) {
        const user = localStorage.getItem("user");
        if (user === null || user === "") {
          store.commit("openLogin");
          return;
        }

        if (this.booking.players === undefined) {
          return;
        }

        this.booking.players.push({
          customerId: JSON.parse(user).id,
          owner: true,
        });
      }
      // shared payment
      for (var i = 0; i < this.booking.players.length; i++) {
        let player = this.booking.players[i];
        player.addToSale = false;
        if (player.selected || player.owner) {
          player.addToSale = true;
        }
        switch (player.position) {
          case 0:
            player.team = 0;
            player.side = 0;
            break;
          case 1:
            player.team = 1;
            player.side = 1;
            break;
          case 2:
            player.team = 0;
            player.side = 1;
            break;
          case 3:
            player.team = 1;
            player.side = 0;
            break;
        }
      }
      //if positioning on match, only send 1 player on create match
      if(this.isMatch){
        this.booking.players = this.booking.players.filter(player => player.customerId);
      }
      return this.booking.players;
    },
    getTotalPlayersSelected() {
      let count = 0;
      if (this.booking.players === undefined) {
        return 1;
      }
      if (this.fromJoin) {
        count = this.booking.players.length;
      } else {
        count = this.booking.players.filter((y: any) => y.selected).length;
      }
      return count === 0 ? 1 : count;
    },
    setFullPayment(option: boolean) {
      this.fullPayment = option;
      this.checkShowTaxes();
    },
    checkShowTaxes(){
      if(this.isMatch || this.fullPayment){
        return this.totalPriceWithoutTaxes = this.fullPaymentPriceWithoutTaxes
      }
      return this.totalPriceWithoutTaxes = this.sharedPaymentPriceWithoutTaxes
    },
    fixIphoneHeight() {
      if (AppsHelper.isSafariOrIosWebView()) {
        const resultsContainer = document.querySelector(".wrapperCheckout");
        if (resultsContainer) {
          resultsContainer.classList.add("pb-100");
        }
      }
    },
  },
});
</script>
<style scoped>
.checkoutPolicy {
  border-bottom: 1px solid rgba(255, 255, 255, 0.158);
  height: 80px;
  transition: 0.4s;
  overflow: hidden;
}
.paymentWrapper {
  margin: 0 auto;
  align-content: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.paymentBoxLeft {
  border-radius: 24px;
  background: var(--background-color-box);
  /* box-shadow: inset 0px 0px 12px rgba(255, 255, 255, 0.15); */
}

.paymentBoxRight {
  border-radius: 24px;
}

.paymentBoxLeft .custom-gradient {
  border-bottom: 1px solid #ffffff21;
}

@media (min-width: 1100px) and (max-width: 1300px) {
  .paymentBoxRight {
    min-width: 50% !important;
  }

  .paymentBoxLeft {
    min-width: 50% !important;
  }
}

@media (min-width: 767px) {
  .addPlayers {
    width: 108px;
  }

  .paymentBoxLeft {
    width: 50%;
    min-width: 612px;
    /* height: 754px; */
  }

  .paymentBoxRight {
    width: 50%;
    min-width: 612px;
    height: 754px;
    background: var(--background-color-box);
    /* box-shadow: inset 0px 0px 12px rgba(255, 255, 255, 0.15); */
  }

  .multiplier {
    margin: 0 auto 14px auto;
  }
}

.multiplier {
  display: flex;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: var(--color-text-medium, #1c2a41);
  width: 39px;
}

.paymentOption {
  border-radius: 16px;
  border: 1px solid #1c2a41;
}

@media (max-width: 767px) {
  .paymentOption {
    background-color: var(--background-color-box);
    box-shadow: inset 0px 0px 12px rgba(255, 255, 255, 0.15);
    align-items: start;
  }

  .bottomTotal {
    background-color: var(--background-color-box);
    box-shadow: inset 0px 0px 12px rgba(255, 255, 255, 0.15);
  }

  .bottomTotal {
    border: 1px solid rgba(255, 255, 255, 0.192);
    border-radius: 16px;
  }
}

.bottomTotal {
  border-bottom: 1px solid rgba(255, 255, 255, 0.192);
  bottom: 0;
}

.customBorder {
  background: linear-gradient(
        var(--background-color-button),
        var(--background-color-button)
      )
      padding-box,
    linear-gradient(60deg, var(--color1), var(--color2)) border-box;
  border: 1px solid transparent;
}

.addPlayers {
  border: 2px solid transparent;
  border-radius: 8px;
  height: 128px;
}

.check {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #586577;
}

.customBorder .paySelected::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 28px;
  height: 28px;
  background-repeat: no-repeat;
  background-image: url("../assets/images/plCheck.svg");
  background-size: 100%;
}

@media (max-width: 767px) {
  .addPlayers {
    right: 20px;
    top: 12%;
    width: 80px;
    height: 95px;
  }

  .paymentOption .check {
    width: 20px;
    height: 20px;
  }

  .paySelected::after {
    width: 20px !important;
    height: 20px !important;
  }
}

.playerIcon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-image: linear-gradient(to right, var(--color1), var(--color2));
  margin: 0 auto;
}

.playerIcon::after {
  content: "";
  position: absolute;
  height: 24px;
  width: 24px;
  background-size: 100%;
  background-repeat: no-repeat;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-image: url("../assets/images/userw.svg");
}

@media (max-width: 767px) {
  .playerIcon {
    width: 32px;
    height: 32px;
  }

  .playerIcon::after {
    height: 16px;
    width: 16px;
  }
}

.buttomPayMode {
  border-radius: 32px;
  padding: 14px 0;
  width: 120px;
  background-image: linear-gradient(to right, var(--color1), var(--color2));
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 767px) {
  .buttomPayMode {
    border-radius: 32px;
    width: 327px;
    padding: 14px 0;
    background-image: linear-gradient(to right, var(--color1), var(--color2));
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 767px) {
  .check {
    height: 20px !important;
    width: 20px !important;
  }
}

@media (max-width: 1100px) and (min-width: 767px) {
  .wrapperCheckout {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
}

.playerSelected {
  background: linear-gradient(
        var(--background-color-box),
        var(--background-color-box)
      )
      padding-box,
    linear-gradient(60deg, var(--color1), var(--color2)) border-box;
  border: 1px solid transparent;
}

.playerSelected .check::after {
  content: "";
  background-image: url("../assets/images/plCheck.svg");
  height: 25px;
  width: 25px;
  left: 50%;
  top: 50%;
  position: absolute;
  background-size: 100%;
  transform: translate(-50%, -50%);
}
</style>